import React from 'react';
import Skeleton from '@wconcept/wconcept-ui-renewal/components/atoms/Skeleton';
import * as S from './style';

const MegaPromotionSkeleton = () => (
  <S.Box>
    <Skeleton className="main-banner" />
    <ul className="main-banner-pc">
      <li>
        <Skeleton className="thum" />
      </li>
      <li>
        <Skeleton className="thum" />
      </li>
      <li>
        <Skeleton className="thum" />
      </li>
      <li>
        <Skeleton className="thum" />
      </li>
      <li>
        <Skeleton className="thum" />
      </li>
    </ul>
  </S.Box>
);

export default MegaPromotionSkeleton;
